import { isNoProdDomain } from '../../utils/aem-utils';

const LOG_STORE_PARAM = 'logStore';

export const logStore = () => {
  const url = new URL(window.location.href);
  return url.searchParams.has(LOG_STORE_PARAM) || isNoProdDomain();
};
